import { render, staticRenderFns } from "./MixReport.vue?vue&type=template&id=6734fbd7"
import script from "./MixReport.vue?vue&type=script&lang=js"
export * from "./MixReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports